// @flow
import React from 'react'
import styled, { css } from 'styled-components'
import { Title } from 'src/theme/globalStyle'
import { media } from 'src/theme/style-utils'

const StyledRoomSummary = styled.div`
  display: flex;
  justify-content: space-between;

  ${media.phone`
    margin: 30px 20px;
  `}
  
  ${media.tabletLarge`
    margin: 30px 40px;
  `}
  
  ${(props: { noMargin?: boolean }) =>
    props.noMargin &&
    css`
      margin: 0;
    `};
`

const StyledDetail = styled.div``

const StyledRoomImage = styled.img``

export const RoomSummary = ({ name, noMargin }: { name: string, noMargin?: boolean }) => {
  return (
    <StyledRoomSummary noMargin={noMargin}>
      <StyledDetail>
        <Title noMargin={true}>{name}</Title>
      </StyledDetail>
      <StyledRoomImage src="" />
    </StyledRoomSummary>
  )
}



// WEBPACK FOOTER //
// ./src/components/RoomSummary/index.js